var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAustria(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496.077 345.043C506.368 317.311 512 287.314 512 256C512 224.686 506.368 194.691 496.077 166.957L256 144.696L15.923 166.957C5.633 194.691 0 224.686 0 256C0 287.314 5.633 317.311 15.923 345.043L256 367.304L496.077 345.043Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256 512C366.07 512 459.906 442.528 496.076 345.043H15.922C52.094 442.528 145.928 512 256 512Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256 0C145.928 0 52.094 69.472 15.922 166.957H496.077C459.906 69.472 366.07 0 256 0Z",
    fill: "#D80027"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAustria);
export default __webpack_public_path__ + "static/media/austria.842c658d02d99730492baab802464d17.svg";
export { ForwardRef as ReactComponent };